import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import * as yup from "yup";

import {
  Container,
  Content,
  Title,
  Field,
  Label,
  Colaborador,
  ListaColaboradores,
  InputFile,
  InputSelect,
} from "./styles";
import { MdDelete } from "react-icons/md";
import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";

import { retira_acentos } from "../../../../../utils/Utils";

const UpdateEpisodio = (props) => {
  const [episodio, setEpisodio] = useState({
    titulo: "",
    fk_playlist: "",
    youtube_embed: "",
    data_inicio: "",
    data_fim: "",
    publico: 1,
    manual_bordo: "",
    url_amigavel: "",
  });

  const [id, setId] = useState(null);

  const [playlist, setPlaylist] = useState(null);

  const [listaHosts, setListaHosts] = useState(null);
  const [selectedHosts, setSelectedHosts] = useState(null);
  const [hostMomentaneo, setHostMomentaneo] = useState(null);

  const [listaConvidados, setListaConvidados] = useState(null);
  const [selectedConvidados, setSelectedConvidados] = useState(null);
  const [convidadoMomentaneo, setConvidadoMomentaneo] = useState(null);

  const [initialHost, setInitialHost] = useState(null);
  const [initialConvidado, setInitialConvidado] = useState(null);

  const [imagem, setImagem] = useState(null);
  const [nameImagem, setNameImagem] = useState(null);

  useEffect(() => {
    api
      .get("/webserie/colaboradores?filter=host")
      .then((res) => {
        setListaHosts(res.data);
      })
      .catch((err) => console.error(err));

    api
      .get("/webserie/colaboradores?filter=convidado")
      .then((res) => {
        setListaConvidados(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    loadAuth();
  }, []);

  useEffect(() => {
    if (!id) return;
    api
      .get(`/webserie/join/colaboradoresFiltered?id=${id}&filterType=episodio`)
      .then((res) => {
        if (res.data.length <= 0) {
          setInitialHost([]);
          setInitialConvidado([]);
          setSelectedHosts([]);
          setSelectedConvidados([]);

          return;
        }
        let hosts = [];
        let convidados = [];
        let hostsInciais = [];
        let convidadosInciais = [];

        res.data.forEach((item) => {
          if (item.colaborador.cargo.cargo === "host") {
            hosts.push(`${item.colaborador?.id}-${item.colaborador?.nome}`);
            hostsInciais.push({
              nome: `${item.colaborador?.id}-${item.colaborador?.nome}`,
              id_tabela_relacionamento: item.id,
            });
          } else if (item.colaborador.cargo.cargo === "convidado") {
            convidados.push(
              `${item.colaborador?.id}-${item.colaborador?.nome}`
            );
            convidadosInciais.push({
              nome: `${item.colaborador?.id}-${item.colaborador?.nome}`,
              id_tabela_relacionamento: item.id,
            });
          }
        });

        setInitialHost(hostsInciais);
        setInitialConvidado(convidadosInciais);

        setSelectedHosts(hosts);
        setSelectedConvidados(convidados);
      })
      .catch((err) => console.error(err));
  }, [id]);

  const uploadCapa = async () => {
    if (!imagem) {
      return episodio.url_amigavel ? true : false;
    }

    const payload = new FormData();
    payload.append("file", imagem);
    payload.append("folder", "cursos/new_dash");
    payload.append("url", nameImagem);

    return api
      .post("/curso/upload-content", payload)
      .then((res) => {
        if (res.data.status === "success") {
          return true;
        }
      })
      .catch((err) => {
        swal(
          "Erro ao inserir o arquivo",
          "Por favor, verifique se seu arquivo está no formato adequado (imagem .jpg)",
          "error"
        );
        console.error(err);
      });
  };

  const clear = (type, index) => {
    let arrayManipulavel;

    if (type === "host") {
      arrayManipulavel = selectedHosts;
      setSelectedHosts([]);

      arrayManipulavel.splice(index, 1);

      setSelectedHosts(() => [...arrayManipulavel]);
    } else if (type === "convidado") {
      arrayManipulavel = selectedConvidados;
      setSelectedConvidados([]);

      arrayManipulavel.splice(index, 1);

      setSelectedConvidados(() => [...arrayManipulavel]);
    }
  };

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  useEffect(() => {
    api
      .get("webseries_playlist")
      .then((res) => {
        setPlaylist(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const formatDate = (date) => {
    const formated = `${date.getFullYear()}-${
      date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    }-${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}T${
      date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
    }:${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;

    return formated;
  };

  const corrigeFusoInicial = (date) => {
    const dateObject = new Date(date);
    // Correção do fuso
    dateObject.setHours(dateObject.getHours() + 3);

    // Formatação para entrar no input da local date-time
    const formatedDate = formatDate(dateObject);

    return formatedDate;
  };

  useEffect(() => {
    const id = window.location.href.split("?")[1];
    if (!id || id === "") {
      window.location.href = "/admin/webserie-episodio";
    }
    api
      .get(`/webserie/episodio/${id}`)
      .then((res) => {
        if (res.data.length <= 0) {
          window.location.href = "/admin/webserie-episodio";
        }

        const epData = res.data[0];
        epData.data_fim = corrigeFusoInicial(epData.data_fim);
        epData.data_inicio = corrigeFusoInicial(epData.data_inicio);

        setEpisodio(epData);

        setId(id);
      })
      .catch((err) =>
        swal(`Erro: ${err.message}`).then(
          () => (window.location.href = "/admin/webserie-episodio")
        )
      );
  }, []);

  const clearNomeCapa = (nome) => {
    let cleanedName = nome.replace(/  */g, "-");
    cleanedName = cleanedName.replace(/\+ */g, "");
    cleanedName = cleanedName.replace(/\(/g, "");
    cleanedName = cleanedName.replace(/\)/g, "");
    cleanedName = cleanedName.replace(/.jpg/, "");
    cleanedName = cleanedName.replace(/.jpeg/, "");
    cleanedName = cleanedName.replace(/\./g, "");

    cleanedName = cleanedName.toLowerCase();
    cleanedName = retira_acentos(cleanedName);

    return cleanedName;
  };

  useEffect(() => {
    if (!imagem) return;

    const nomeCapa = imagem.name;

    if (imagem.type !== "image/jpg" && imagem.type !== "image/jpeg") {
      swal("As imagens devem sempre ser .jpg");
      return;
    }

    const cleanName = clearNomeCapa(nomeCapa);
    setNameImagem(cleanName);

    setEpisodio({ ...episodio, url_amigavel: cleanName });
  }, [imagem]);

  const alteraColaboradores = () => {
    // Deleta convidados
    initialConvidado.forEach((conviadoInicial) => {
      // Se um nome que estava no inicio não tiver dentre as selecionadas esse nome é deletado

      if (!selectedConvidados.includes(conviadoInicial.nome)) {
        api
          .delete(
            `webserie/join/colaboradores/${conviadoInicial.id_tabela_relacionamento}`
          )
          .then((res) => console.log(res))
          .catch((err) => console.error(err));
      }
    });

    if (selectedConvidados.length > 0 && selectedConvidados !== null) {
      selectedConvidados.forEach((convidadoSelecionado) => {
        const tamanhoArrayInicial = initialConvidado.length;
        let cont = 0;
        let jaExisteRegistro = false;
        while (cont <= tamanhoArrayInicial && !jaExisteRegistro) {
          if (convidadoSelecionado === initialConvidado[cont]?.nome) {
            jaExisteRegistro = true;
          }

          cont++;
        }

        if (!jaExisteRegistro) {
          const data = {
            fk_id_episodio: id,
            fk_id_colaborador: convidadoSelecionado.split("-")[0],
          };

          api
            .post("/webserie/join/colaboradores", data)
            .then((res) => console.log(res))
            .catch((err) => console.error(err));
        }
      });
    }

    // Deleta hosts
    initialHost.forEach((hostInicial) => {
      // Se um nome que estava no inicio não tiver dentre as selecionadas esse nome é deletado
      if (!selectedHosts.includes(hostInicial.nome)) {
        api
          .delete(
            `webserie/join/colaboradores/${hostInicial.id_tabela_relacionamento}`
          )
          .then((res) => console.log(res))
          .catch((err) => console.error(err));
      }
    });

    if (selectedHosts.length > 0 && selectedHosts !== null) {
      selectedHosts.forEach((hostSelecionado) => {
        const tamanhoArrayInicial = initialHost.length;
        let cont = 0;
        let jaExisteRegistro = false;
        while (cont <= tamanhoArrayInicial && !jaExisteRegistro) {
          if (hostSelecionado === initialHost[cont]?.nome) {
            jaExisteRegistro = true;
          }

          cont++;
        }

        if (!jaExisteRegistro) {
          const data = {
            fk_id_episodio: id,
            fk_id_colaborador: hostSelecionado.split("-")[0],
          };

          api
            .post("/webserie/join/colaboradores", data)
            .then((res) => console.log(res))
            .catch((err) => console.error(err));
        }
      });
    }
  };

  const create = async () => {
    const episodioValidation = await yup.object().shape({
      titulo: yup
        .string("Necessário que informe o titulo")
        .required("Necessário que informe o titulo"),
      youtube_embed: yup
        .string("Necessário que informe o link do youtube")
        .required("Necessário que informe o link do youtube"),
      data_inicio: yup
        .string("Necessário que informe a data de inicio")
        .required("Necessário que informe a data de inicio"),
      data_fim: yup
        .string("Necessário que informe a data de fim")
        .required("Necessário que informe a data de fim"),
      publico: yup
        .string("Necessário que informe se a live será publica")
        .required("Necessário que informe a live será publica"),
      url_amigavel: yup
        .string("Necessário que informe se a url amigavel")
        .required("Necessário que informe a url amigavel"),
      slogan: yup
        .string("Necessário que informe o slogan")
        .required("Necessário que informe o slogan"),
    });

    if (
      (selectedHosts?.length === 0 || selectedHosts === null) &&
      (selectedConvidados?.length === 0 || selectedConvidados === null)
    ) {
      const cricaoSemColaborador = await swal({
        title: "Você tem certeza ?",
        text:
          "Caso clique em OK o episódio será criado sem host e sem convidado",
        type: "warning",
      }).then((res) => {
        return res ? true : false;
      });

      if (!cricaoSemColaborador) {
        return;
      }
    }

    alteraColaboradores();

    const confirmation = await uploadCapa();

    if (!confirmation) {
      swal("Por favor, faça o upload de pelo menos uma imagem");
      return;
    }

    try {
      await episodioValidation.validate(episodio, { abortEarly: true });
      api
        .put(`/admin/webserie/episodio/${id}`, episodio)
        .then(async (res) => {
          if (res.status === 200)
            setTimeout(() => swal("Sucesso na atualização !"), 500);
        })
        .catch((err) => {
          swal("Não foi possível atualizar o episodio", err, "").then((res) =>
            props.history.push("/admin/lives")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Atualizar Episodio</Title>
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Título do Episodio"
                placeholder="Título do Episodio"
                value={episodio.titulo}
                onChange={(e) => {
                  setEpisodio({ ...episodio, titulo: e.target.value });
                }}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <textarea
                control={Input}
                label="Slogan do Episódio"
                placeholder="Slogan do Episódio"
                value={episodio.slogan}
                onChange={(e) => {
                  setEpisodio({ ...episodio, slogan: e.target.value });
                }}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Label> Webserie </Label>
                <select
                  onChange={(e) => {
                    setEpisodio({
                      ...episodio,
                      fk_playlist: e.target.value.split("[]")[0],
                      manual_bordo: e.target.value.split("[]")[1],
                    });
                  }}
                  value={episodio.fk_playlist}
                >
                  <option value={"[]"}> Episódio Independente </option>
                  {playlist?.map((item) => (
                    <option
                      value={`${item.id}[]${
                        item.link_manual_bordo || item.link_manualbordo || ""
                      }`}
                    >
                      {" "}
                      {item.titulo || item.nome}
                    </option>
                  ))}
                </select>
                <b> Atenção: </b> sempre que que alterar a webserie o{" "}
                <b> manual de bordo </b> será modificado para o padrão da
                Webserie
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Link do Youtube"
                placeholder="Link do Youtube"
                value={episodio.youtube_embed}
                onChange={(e) => {
                  setEpisodio({ ...episodio, youtube_embed: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                type="datetime-local"
                label="Data Inicio"
                placeholder="Data Inicio"
                value={episodio.data_inicio}
                onChange={(e) => {
                  setEpisodio({ ...episodio, data_inicio: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                type="datetime-local"
                label="Data Fim"
                placeholder="Data Fim"
                value={episodio.data_fim}
                onChange={(e) => {
                  setEpisodio({ ...episodio, data_fim: e.target.value });
                }}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Label> Episódio Público </Label>

                <select
                  onChange={(e) =>
                    setEpisodio({ ...episodio, publico: e.target.value })
                  }
                  value={episodio.publico}
                >
                  <option value={1} >
                    Público{" "}
                  </option>
                  <option value={0}> Privado </option>
                </select>
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Form.Field
                  value={episodio.manual_bordo}
                  control={Input}
                  label="Manual de Bordo"
                  placeholder="Manual de Bordo"
                  onChange={(e) => {
                    setEpisodio({
                      ...episodio,
                      manual_bordo: e.target.value,
                    });
                  }}
                  value={episodio.manual_bordo}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Field>
                <Label>Capa do Episódigo</Label>
                <InputFile
                  name="capa"
                  type="file"
                  onChange={(e) => {
                    const capa = e.target.files[0];
                    setImagem(capa);
                  }}
                />
                <div></div>
              </Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                value={episodio.url_amigavel}
                control={Input}
                label="URL Amigavel (Ao fazer o upload da imagem a URL irá aparecer aqui para conferir)"
                placeholder="URL Amigavel"
                readOnly={true}
              />
            </Form.Group>
            <div>
              {" "}
              Cadastre novos colaboradores{" "}
              <a href={"/admin/webserie-colaborador/criar"}> aqui </a>
            </div>

            <InputSelect>
              <Label>
                {" "}
                Adicionar Host <br />{" "}
              </Label>

              <Colaborador>
                <select
                  onChange={(e) => setHostMomentaneo(e.target.value)}
                  value={hostMomentaneo}
                >
                  <option value={""}> Selecione o Host </option>

                  {listaHosts?.map((convidado) => (
                    <option value={`${convidado.id}-${convidado.nome}`}>
                      {" "}
                      {convidado.nome}
                    </option>
                  ))}
                </select>
                <Button
                  onClick={() => {
                    if (
                      hostMomentaneo === "" ||
                      selectedHosts?.includes(hostMomentaneo)
                    ) {
                      return;
                    }

                    let arrayManipulavel = selectedHosts;
                    setSelectedHosts(null);

                    if (
                      arrayManipulavel?.length <= 0 ||
                      arrayManipulavel === null ||
                      !arrayManipulavel
                    ) {
                      arrayManipulavel = [hostMomentaneo];
                    } else {
                      arrayManipulavel.push(hostMomentaneo);
                    }

                    setSelectedHosts(arrayManipulavel);
                    setHostMomentaneo("");
                  }}
                >
                  Adicionar Host
                </Button>
              </Colaborador>
            </InputSelect>
            <InputSelect>
              <Label>
                {" "}
                Adicionar Convidados <br />{" "}
              </Label>

              <Colaborador>
                <select
                  onChange={(e) => {
                    setConvidadoMomentaneo(e.target.value);
                  }}
                  value={convidadoMomentaneo}
                >
                  <option value={""}> Selecione o convidado </option>
                  {listaConvidados?.map((convidado) => (
                    <option value={`${convidado.id}-${convidado.nome}`}>
                      {" "}
                      {convidado.nome}
                    </option>
                  ))}
                </select>
                <Button
                  onClick={() => {
                    if (
                      convidadoMomentaneo === "" ||
                      selectedConvidados?.includes(convidadoMomentaneo)
                    ) {
                      return;
                    }

                    let arrayManipulavel = selectedConvidados;

                    if (
                      arrayManipulavel?.length <= 0 ||
                      arrayManipulavel === null ||
                      !arrayManipulavel
                    ) {
                      arrayManipulavel = [convidadoMomentaneo];
                    } else {
                      arrayManipulavel.push(convidadoMomentaneo);
                    }

                    setSelectedConvidados(arrayManipulavel);
                    setConvidadoMomentaneo("");
                  }}
                >
                  Adicionar Convidado
                </Button>
              </Colaborador>
            </InputSelect>
            <ListaColaboradores>
              <div>
                <span> Hosts </span>
                <div>
                  {selectedHosts?.map(
                    (item, index) =>
                      item && (
                        <div>
                          {" "}
                          {item}{" "}
                          <MdDelete onClick={() => clear("host", index)} />{" "}
                        </div>
                      )
                  )}
                </div>
              </div>
              <div>
                <span> Convidados </span>
                {selectedConvidados?.map(
                  (item, index) =>
                    item && (
                      <div>
                        {" "}
                        {item}{" "}
                        <MdDelete onClick={() => clear("convidado", index)} />{" "}
                      </div>
                    )
                )}
              </div>
            </ListaColaboradores>
            <Divider hidden />
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => {
                  create();
                }}
              >
                Enviar
              </Form.Field>
              <Link to="/admin/webserie-episodio">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(UpdateEpisodio);
